import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { ListWarehousesComponent } from './components/list-warehouses/list-warehouses.component';
import { UiModule } from 'src/app/ui/ui.module';
import { FormWarehouseComponent } from './components/form-warehouse/form-warehouse.component';



@NgModule({
  declarations: [
    ListWarehousesComponent,
    FormWarehouseComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule
  ]
})
export class WarehosesModule { }
